
(function () {
  'use strict';

  if (window.__ADV_PERSONALISE_BOOTED__) return;
  window.__ADV_PERSONALISE_BOOTED__ = true;

  var ROOT_SEL = '.advance-personalise';
  var POSITIONS = ['top', 'middle', 'bottom'];

  var MESSAGES = {
    font: 'Please select a font style.',
    terms: 'Please agree to the Terms & Conditions.',
    empty: 'Please enter some personalisation details first.',
    needText: 'Please enter your text or close this section.',
    needImage: 'Please upload an image or close this section.',
    needIcon: 'Please select an embellishment or close this section.',
    noVariant: 'Product variant not found.',
    noPersonalise: 'Personalise product is not configured.'
  };
  window.PERSONALISE_MESSAGES = MESSAGES;

  /* ---------------------------------------------------------------- utils */

  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  function emptyPositionState() {
    return {
      type: null, value: null, font: null, fontName: null,
      imageData: null, filename: null, iconIndex: null, rawFile: null,
      embellishment: { checked: false, iconName: '', iconImg: '', position: '' }
    };
  }

  /* ============================================================
     INSTANCE
     ============================================================ */
  function AdvPersonalise(root) {
    this.root = root;
    this.productId = root.getAttribute('data-product-id') || '';
    this.itemKey = root.getAttribute('data-item-key') || root.getAttribute('data-key') || 'default';
    this.isBuilder = root.getAttribute('data-byb-type') === 'true';

    this.sides = this._readSides();
    this.state = {};
    this.selectedFonts = {};
    this.activeMode = {};
    this.touchedMap = {};
    this.lastEditedSide = this.sides.length ? this.sides[0].slug : null;

    this._buildEmptyState();
    this._bind();
    this.buildIconGrids();
    this.restore();
    this.hydrateFromDom();

    root.__advPersonalise = this;
  }

  var P = AdvPersonalise.prototype;

  /* ---------------------------------------------------- scoped selectors */

  P.$ = function (sel) { return this.root.querySelector(sel); };
  P.$$ = function (sel) { return toArray(this.root.querySelectorAll(sel)); };
  P.id = function (dataId) { return this.root.querySelector('[data-id="' + dataId + '"]'); };
  P.ids = function (dataId) { return this.$$('[data-id="' + dataId + '"]'); };

  /* ------------------------------------------------------------- sides */

  /* Sides are read from the DOM, not from the global window.ENGRAVING_SIDES,
     so two drawers rendered by different products never overwrite each other. */
  P._readSides = function () {
    var seen = {};
    var out = [];
    var self = this;

    this.$$('.main-tab[data-side]').forEach(function (tab) {
      var slug = tab.getAttribute('data-side');
      if (!slug || seen[slug]) return;
      seen[slug] = true;
      out.push({ slug: slug, label: (tab.textContent || slug).trim() });
    });

    /* single-side drawers have no tab bar — fall back to panels */
    this.$$('.tab-panel[data-side]').forEach(function (panel) {
      var slug = panel.getAttribute('data-side');
      if (!slug || seen[slug]) return;
      seen[slug] = true;
      var lbl = self.root.querySelector('.split-preview-col[data-side="' + slug + '"] .split-preview-label');
      out.push({ slug: slug, label: lbl ? lbl.textContent.trim() : slug });
    });

    if (!out.length && window.ENGRAVING_SIDES) out = window.ENGRAVING_SIDES.slice();
    return out;
  };

  P.sideLabel = function (slug) {
    for (var i = 0; i < this.sides.length; i++) {
      if (this.sides[i].slug === slug) return this.sides[i].label;
    }
    return slug;
  };

  /* Only positions that actually exist in this drawer for this side. */
  P.positionsFor = function (side) {
    var found = this.$$('.accordion-section[data-side="' + side + '"]').map(function (sec) {
      return sec.getAttribute('data-position');
    }).filter(Boolean);
    return found.length ? found : POSITIONS.slice();
  };

  P.eachSidePos = function (fn) {
    var self = this;
    this.sides.forEach(function (s) {
      POSITIONS.forEach(function (pos) { fn.call(self, s.slug, pos, s); });
    });
  };

  P._buildEmptyState = function () {
    var st = {}, fonts = {}, modes = {};
    this.sides.forEach(function (s) {
      st[s.slug] = {}; fonts[s.slug] = {}; modes[s.slug] = {};
      POSITIONS.forEach(function (pos) {
        st[s.slug][pos] = emptyPositionState();
        fonts[s.slug][pos] = '';
        modes[s.slug][pos] = 'text';
      });
    });
    this.state = st;
    this.selectedFonts = fonts;
    this.activeMode = modes;
    this.touchedMap = {};
  };

  P.get = function (side, pos) {
    return (this.state[side] && this.state[side][pos]) || null;
  };

  P.mode = function (side, pos) {
    return (this.activeMode[side] && this.activeMode[side][pos]) || 'text';
  };

  /* ------------------------------------------------------------ storage */

  P.storageKey = function () {
    return 'adv_personalise_' + (this.productId || 'p') + '_' + (this.itemKey || 'default');
  };

  /* ============================================================
     EVENT BINDING  — all delegated on the drawer root
     ============================================================ */
  P._bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (e) { self._onClick(e); });
    root.addEventListener('input', function (e) { self._onInput(e); });
    root.addEventListener('change', function (e) { self._onChange(e); });

    root.addEventListener('dragover', function (e) {
      var zone = e.target.closest('.upload-zone');
      if (!zone || !root.contains(zone)) return;
      e.preventDefault();
      zone.classList.add('dragover');
    });
    root.addEventListener('dragleave', function (e) {
      var zone = e.target.closest('.upload-zone');
      if (zone) zone.classList.remove('dragover');
    });
    root.addEventListener('drop', function (e) {
      var zone = e.target.closest('.upload-zone');
      if (!zone || !root.contains(zone)) return;
      e.preventDefault();
      zone.classList.remove('dragover');
      var file = e.dataTransfer && e.dataTransfer.files[0];
      if (!file || file.type.indexOf('image/') !== 0) return;
      var input = zone.querySelector('input[type=file]');
      var side = input ? input.dataset.side : null;
      var pos = input ? input.dataset.position : null;
      if (!side || !pos) {
        var r = self._resolve(zone);
        side = r.side; pos = r.position;
      }
      if (side && pos) self.readFile(side, pos, file);
    });

    /* embellishment events are dispatched on document by the embellishment
       widget — accept them only if they originate inside this drawer */
    document.addEventListener('embellishment:change', function (e) {
      var d = e.detail || {};
      if (d.root && d.root !== root) return;
      if (e.target && e.target.nodeType === 1 && !root.contains(e.target)) return;
      if (!self.get(d.side, d.position)) return;
      self.state[d.side][d.position].embellishment = {
        checked: d.checked,
        iconName: d.iconName,
        iconImg: d.iconImg,
        position: d.position2 || d.embPosition || ''
      };
      self.updateSplitPreview(d.side, d.position);
      self.save();
    });
  };

  P._resolve = function (el) {
    if (!el) return { side: null, position: null };
    if (el.dataset && el.dataset.side && el.dataset.position) {
      return { side: el.dataset.side, position: el.dataset.position };
    }
    var sec = el.closest('.accordion-section');
    if (sec) return { side: sec.getAttribute('data-side'), position: sec.getAttribute('data-position') };
    var panel = el.closest('.tab-panel');
    return { side: panel ? panel.getAttribute('data-side') : null, position: null };
  };

  /* ------------------------------------------------------------- clicks */

  P._onClick = function (e) {
    var t = e.target;
    var self = this;


    /* close ------------------------------------------------------------ */
    if (t.closest('.drawer-close')) { e.preventDefault(); this.close(); return; }

    /* main tab --------------------------------------------------------- */
    var tab = t.closest('.main-tab');
    if (tab) { this.switchMainTab(tab.dataset.side); return; }

    /* accordion header ------------------------------------------------- */
    var header = t.closest('.accordion-header');
    if (header) {
      e.preventDefault();
      var sec = header.closest('.accordion-section');
      var container = header.closest('.mode-config');
      if (container) {
        toArray(container.querySelectorAll('.accordion-section')).forEach(function (s) {
          if (s !== sec) s.classList.remove('open');
        });
      }
      sec.classList.toggle('open');
      var hSide = sec.getAttribute('data-side');
      var hPos = sec.getAttribute('data-position');
      if (sec.classList.contains('open')) {
        this.switchMode(hSide, hPos, sec.getAttribute('data-active-mode') || this.mode(hSide, hPos));
        this.markTouched(hSide, hPos);
      } else if (!this.hasContent(hSide, hPos)) {
        this.unmarkTouched(hSide, hPos);
        this.clearPositionErrors(hSide, hPos);
      }
      this.syncReviewBtn(hSide);
      return;
    }
    
    /* mode button ------------------------------------------------------ */
    var modeBtn = t.closest('.mode-btn');
    if (modeBtn) {
      e.preventDefault();
      var r = this._resolve(modeBtn);
      var mSide = modeBtn.dataset.side || r.side;
      var mPos = modeBtn.dataset.position || r.position;
      if (mSide && mPos && modeBtn.dataset.mode) {
        this.switchMode(mSide, mPos, modeBtn.dataset.mode);
        this.markTouched(mSide, mPos);
        this.syncReviewBtn(mSide);
      }
      return;
    }

    /* icon ------------------------------------------------------------- */
    var item = t.closest('.icon-item');
    if (item) {
      var ri = this._resolve(item);
      var iSide = item.dataset.side || ri.side;
      var iPos = item.dataset.position || ri.position;
      if (!iSide || !iPos) return;
       this.activeMode[iSide] = this.activeMode[iSide] || {};
      this.activeMode[iSide][iPos] = 'icon'; 

      this.$$('.icon-item[data-side="' + iSide + '"][data-position="' + iPos + '"]')
        .forEach(function (i) { i.classList.remove('selected'); });
      item.classList.add('selected');

      var st = this.get(iSide, iPos);
      if (st) {
        st.type = 'icon';
        st.value = item.dataset.iconName;
        st.iconIndex = parseInt(item.dataset.iconIndex, 10);
        st.imageData = null;
        st.font = null;
      }
      this.markTouched(iSide, iPos);
      this.updateEmbellishmentIconLabel(iSide, iPos);
      this.updateSplitPreview(iSide, iPos);
      this.clearPositionErrors(iSide, iPos);
      this.syncReviewBtn(iSide);
      this.save();
      return;
    }

    /* review / edit ---------------------------------------------------- */
    var reviewBtn = t.closest('.btn-review-all');
      if (reviewBtn) {
        e.preventDefault();
        var rSide = reviewBtn.dataset.side || this.lastEditedSide;
        if (reviewBtn.classList.contains('disabled')) {
          this.validateSide(rSide, true);        
          this.showDrawerError(MESSAGES.empty); 
          return;
        }
        this.handleReviewSide(rSide);
        return;
      }
    if (reviewBtn) { e.preventDefault(); this.handleReviewSide(reviewBtn.dataset.side || this.lastEditedSide); return; }

    if (t.closest('[data-id="btn-edit-shared"]')) { e.preventDefault(); this.handleEdit(); return; }

    var cancelBtn = t.closest('.btn-cancel');
    if (cancelBtn) {
      e.preventDefault();
      var rc = this._resolve(cancelBtn);
      this.handleCancel(cancelBtn.dataset.side || rc.side, cancelBtn.dataset.position || rc.position, cancelBtn.dataset.mode);
      return;
    }

    /* add to cart ------------------------------------------------------ */
    var addBtn = t.closest('[data-id="btn-add-shared_personlize"]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      this.addToCart(addBtn);
      return;
    }

    /* builder add / update --------------------------------------------- */
    var builderBtn = t.closest('[data-id="builder-add-shared"], [data-id="btn-add-shared"]');
    if (builderBtn) {
      e.preventDefault();
      e.stopPropagation();
      this.builderAdd(builderBtn);
      return;
    }
  };

  /* -------------------------------------------------------------- input */

  P._onInput = function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('field-input')) return;

    var side = el.dataset.side;
    var pos = el.dataset.position;
    if (!side || !pos) return;

    var row = el.closest('.field-row');
    var counter = row ? row.querySelector('.char-count') : null;
    if (counter) counter.textContent = el.value.length + '/' + (el.getAttribute('maxlength') || '');

    this.markTouched(side, pos);
    this.updatePreview(side, pos);

    var inputs = this.$$('.field-input[data-side="' + side + '"][data-position="' + pos + '"]');
    var st = this.get(side, pos);
    if (st) {
      st.type = 'text';
      st.value = inputs.map(function (i) { return i.value.trim(); });
      st.font = (this.selectedFonts[side] && this.selectedFonts[side][pos]) || 'inherit';
    }

    this.updateSplitPreview(side, pos);
    if (this.validatePosition(side, pos, false).ok) this.clearPositionErrors(side, pos);
    this.syncReviewBtn(side);
    this.save();
  };

  /* ------------------------------------------------------------- change */

  P._onChange = function (e) {
    var el = e.target;

    /* font select */
    if (el.classList && el.classList.contains('font-select')) {
      var fSide = el.dataset.side, fPos = el.dataset.position;
      if (!fSide || !fPos) return;
      this.selectedFonts[fSide] = this.selectedFonts[fSide] || {};
      this.selectedFonts[fSide][fPos] = el.value;
      this.updatePreview(fSide, fPos);
      var fst = this.get(fSide, fPos);
      if (fst && fst.type === 'text') {
        fst.font = el.value || 'inherit';
        fst.fontName = el.value || null;
        this.updateSplitPreview(fSide, fPos);
      }
      if (el.value && this.validatePosition(fSide, fPos, false).ok) this.clearPositionErrors(fSide, fPos);
      this.syncReviewBtn(fSide);
      this.save();
      return;
    }

    /* file input */
    if (el.matches && el.matches('.upload-zone input[type=file]')) {
      var uSide = el.dataset.side, uPos = el.dataset.position;
      var file = el.files && el.files[0];
      if (uSide && uPos && file) this.readFile(uSide, uPos, file);
      return;
    }

    /* terms checkbox */
    var box = el.closest('[data-id^="terms-check-"]');
    if (box) {
      var did = box.getAttribute('data-id');
      if (did === 'terms-check--all') {
        if (box.checked) {
          var wrap = box.closest('.personalized-terms-checkbox__all');
          if (wrap) wrap.classList.remove('has-error');
          this.clearFieldError('error-terms-all');
        }
        this.save();
        return;
      }
      var tSide = box.dataset.side, tPos = box.dataset.position;
      if (tSide && tPos) {
        if (box.checked && this.validatePosition(tSide, tPos, false).ok) this.clearPositionErrors(tSide, tPos);
        this.syncReviewBtn(tSide);
      }
      this.save();
    }
  };

  /* ============================================================
     TABS / MODES / PREVIEWS
     ============================================================ */
  P.switchMainTab = function (side) {
    if (!side) return;
    this.$$('.main-tab').forEach(function (t) { t.classList.toggle('active', t.dataset.side === side); });
    this.$$('.tab-panel').forEach(function (p) { p.classList.toggle('active', p.dataset.side === side); });
    this.lastEditedSide = side;
  };

  P.switchMode = function (side, position, mode) {
    if (!side || !position || !mode) return;
    this.activeMode[side] = this.activeMode[side] || {};
    this.activeMode[side][position] = mode;

    this.$$('.mode-btn[data-side="' + side + '"][data-position="' + position + '"]').forEach(function (b) {
      b.classList.toggle('active', b.dataset.mode === mode);
    });

    var self = this;
    ['text', 'image', 'icon'].forEach(function (m) {
      var panel = self.id(side + '-' + position + '-' + m);
      if (panel) panel.classList.toggle('active', m === mode);
    });

    var sec = this.section(side, position);
    if (sec) sec.setAttribute('data-active-mode', mode);
  };

  P.section = function (side, position) {
    return this.$('.accordion-section[data-side="' + side + '"][data-position="' + position + '"]');
  };

  P.updatePreview = function (side, position) {
    var box = this.id('preview-area-' + side + '-' + position);
    if (!box) return;
    box.innerHTML = '';
    var hasText = false;
    var font = this.selectedFonts[side] && this.selectedFonts[side][position];

    this.$$('.field-input[data-side="' + side + '"][data-position="' + position + '"]').forEach(function (input) {
      var text = input.value.trim();
      if (!text) return;
      hasText = true;
      var line = document.createElement('div');
      line.textContent = text;
      if (font) line.style.fontFamily = font;
      box.appendChild(line);
    });

    if (!hasText) box.textContent = 'PREVIEW YOUR MESSAGE';
  };

  P.updateEmbellishmentIconLabel = function (side, position) {
    var panel = this.id(side + '-' + position + '-icon');
    if (!panel) return;
    var label = panel.querySelector('.embellisment_icon');
    if (!label) return;
    var selected = panel.querySelector('.icon-item.selected');
    label.textContent = selected ? (selected.getAttribute('data-icon-name') || '') : '';
  };

  P.updateSplitPreview = function (side, position) {
    var s = this.get(side, position);
    var box = this.id('split-box-' + side + '-' + position);
    var group = this.id('split-group-' + side + '-' + position);
    if (!box || !s) return;

    box.innerHTML = '';

    var isEmpty = !s.type ||
      (s.type === 'text' && !(s.value || []).filter(Boolean).length) ||
      (s.type === 'image' && !s.imageData) ||
      (s.type === 'icon' && !s.value);

    if (isEmpty) {
      if (group) group.style.display = 'none';
      box.innerHTML = '<span class="split-preview-empty"></span>';
      return;
    }
    if (group) group.style.display = '';

    if (s.type === 'text') {
      var lines = s.value.filter(Boolean);
      var wrap = document.createElement('div');
      wrap.className = 'split-preview-text';
      var sizes = ['15px', '13px', '16px'];
      lines.forEach(function (line) {
        var span = document.createElement('span');
        span.textContent = line;
        span.style.fontFamily = (s.font && s.font !== 'inherit') ? s.font : 'var(--font-label)';
        span.style.fontSize = sizes[Math.min(lines.length - 1, 2)];
        wrap.appendChild(span);
      });
      box.appendChild(wrap);

    } else if (s.type === 'image') {
      var img = document.createElement('img');
      img.src = s.imageData;
      img.className = 'split-preview-img';
      img.alt = s.filename || 'Uploaded';
      box.appendChild(img);

    } else if (s.type === 'icon') {
      var iconWrap = document.createElement('div');
      iconWrap.className = 'split-preview-icon';
      var pool = (window.ICONS_BY_SIDE && window.ICONS_BY_SIDE[side + '__' + position]) || [];
      var entry = pool[s.iconIndex];
      if (entry && entry.svg) {
        iconWrap.innerHTML = entry.svg;
      } else {
        var src = this.$('.icon-item[data-side="' + side + '"][data-position="' + position + '"][data-icon-name="' + s.value + '"] img');
        if (src) iconWrap.innerHTML = '<img src="' + src.getAttribute('src') + '" alt="">';
      }
      var label = document.createElement('div');
      label.className = 'split-preview-icon-name';
      label.textContent = s.value || '';
      box.appendChild(iconWrap);
      box.appendChild(label);
    }

    var emb = s.embellishment;
    if (emb && (emb.enabled || emb.checked) && (emb.iconName || emb.icon)) {
      var embWrap = document.createElement('div');
      embWrap.className = 'split-preview-embellishment';
      embWrap.setAttribute('data-position', emb.position || '');

      if (emb.iconImg || emb.iconImage) {
        var embImg = document.createElement('img');
        embImg.src = emb.iconImg || emb.iconImage;
        embImg.className = 'split-preview-embellishment-img';
        embImg.alt = emb.iconName || emb.icon || 'Embellishment';
        embWrap.appendChild(embImg);
      }

      var embLabel = document.createElement('div');
      embLabel.className = 'split-preview-embellishment-label hidden';
      embLabel.textContent = emb.iconName || emb.icon || '';
      embWrap.appendChild(embLabel);

      if (emb.position) {
        var embPos = document.createElement('div');
        embPos.className = 'split-preview-embellishment-position hidden';
        embPos.textContent = emb.position;
        embWrap.appendChild(embPos);
      }
      box.appendChild(embWrap);
    }
  };

  P.refreshAllSplitPreviews = function () {
    this.eachSidePos(function (side, pos) { this.updateSplitPreview(side, pos); });
  };

  P.updateStateBar = function () {
    var self = this;
    this.sides.forEach(function (sideObj) {
      var side = sideObj.slug;
      var el = self.id('state-' + side + '-display');
      var tabBtn = self.$('.main-tab[data-side="' + side + '"]');
      var parts = [];

      POSITIONS.forEach(function (pos) {
        var s = self.get(side, pos);
        if (!s || !s.type) return;
        if (s.type === 'text') {
          var lines = (s.value || []).filter(Boolean);
          if (lines.length) parts.push(lines.join(' \u00b7 '));
        } else if (s.type === 'image') {
          parts.push(s.filename || 'Image uploaded');
        } else if (s.type === 'icon' && s.value) {
          parts.push(s.value);
        }
      });

      if (tabBtn) tabBtn.classList.toggle('has-data', parts.length > 0);
      if (!el) return;
      if (!parts.length) { el.textContent = '\u2014'; el.classList.remove('filled'); return; }
      el.textContent = parts.join(' | ');
      el.classList.add('filled');
    });
  };

  /* ============================================================
     ICON GRIDS
     ============================================================ */
  P.buildIconGrids = function () {
    var self = this;
    this.eachSidePos(function (side, pos) {
      var grid = self.id('icon-grid-' + side + '-' + pos);
      if (!grid) return;

      /* Liquid already rendered the icons — only stamp the missing
         data-position attribute so scoped selectors match. */
      var existing = toArray(grid.querySelectorAll('.icon-item'));
      if (existing.length) {
        existing.forEach(function (item, i) {
          if (!item.dataset.side) item.dataset.side = side;
          if (!item.dataset.position) item.dataset.position = pos;
          if (!item.dataset.iconIndex) item.dataset.iconIndex = String(i);
        });
        return;
      }

      var icons = (window.ICONS_BY_SIDE && window.ICONS_BY_SIDE[side + '__' + pos]) || [];
      if (!icons.length) return;
      grid.innerHTML = icons.map(function (icon, i) {
        return '<div class="icon-item" data-side="' + side + '" data-position="' + pos +
          '" data-icon-index="' + i + '" data-icon-name="' + (icon.name || '') + '">' + (icon.svg || '') + '</div>';
      }).join('');
      self.updateEmbellishmentIconLabel(side, pos);
    });
  };

  /* ============================================================
     FILE UPLOAD
     ============================================================ */
  P.readFile = function (side, position, file) {
    var self = this;
    var st = this.get(side, position);
    if (!st) return;
    st.rawFile = file;

    var reader = new FileReader();
    reader.onload = function (ev) {
      var imgEl = self.id(side + '-' + position + '-img-preview');
      var nameEl = self.id(side + '-' + position + '-img-name');
      var zone = self.id('upload-zone-' + side + '-' + position);

      if (imgEl) { imgEl.src = ev.target.result; imgEl.style.display = 'block'; }
      if (nameEl) { nameEl.textContent = file.name; nameEl.style.display = 'block'; }
      if (zone) {
        zone.classList.add('has-file');
        var ut = zone.querySelector('.upload-text');
        var ui = zone.querySelector('.upload-icon');
        if (ut) ut.style.display = 'none';
        if (ui) ui.style.display = 'none';
      }

      st.type = 'image';
      st.imageData = ev.target.result;
      st.filename = file.name;
      st.value = null;
      st.font = null;
      st.iconIndex = null;

      self.markTouched(side, position);
      self.updateSplitPreview(side, position);
      if (self.validatePosition(side, position, false).ok) self.clearPositionErrors(side, position);
      self.syncReviewBtn(side);
      self.save();
    };
    reader.readAsDataURL(file);
  };

  /* ============================================================
     TOUCHED / CONTENT / RULES
     ============================================================ */
  P.markTouched = function (side, pos) { if (side && pos) this.touchedMap[side + '__' + pos] = true; };
  P.unmarkTouched = function (side, pos) { if (side && pos) delete this.touchedMap[side + '__' + pos]; };
  P.isTouched = function (side, pos) { return !!this.touchedMap[side + '__' + pos]; };
  P.clearAllTouched = function () { this.touchedMap = {}; };

  P.hasContent = function (side, position) {
    var mode = this.mode(side, position);
    if (mode === 'text') {
      return this.$$('.field-input[data-side="' + side + '"][data-position="' + position + '"]')
        .some(function (i) { return i.value.trim(); });
    }
    if (mode === 'image') {
      var img = this.id(side + '-' + position + '-img-preview');
      return !!(img && img.getAttribute('src') && img.style.display !== 'none');
    }
    if (mode === 'icon') {
      return !!this.$('.icon-item.selected[data-side="' + side + '"][data-position="' + position + '"]');
    }
    return false;
  };

  /* Per-position flags first, tab-panel flags as fallback. */
  P.rules = function (side, position) {
    var sec = this.section(side, position);
    var panel = this.$('.tab-panel[data-side="' + side + '"]');
    function flag(attr) {
      if (sec && sec.hasAttribute(attr)) return sec.getAttribute(attr) === 'true';
      if (panel && panel.hasAttribute(attr)) return panel.getAttribute(attr) === 'true';
      return false;
    }
    return {
      fontCompulsory: flag('data-font-compulsory'),
      termsRequired: flag('data-terms-required'),
      termsRequiredImage: flag('data-terms-required-image')
    };
  };

  /* ============================================================
     ERRORS
     ============================================================ */
  P.showFieldError = function (id, msg) {
    var el = this.id(id);
    if (!el) return;
    el.textContent = msg;
    el.classList.remove('hidden');
  };

  P.clearFieldError = function (id) {
    var el = this.id(id);
    if (!el) return;
    el.textContent = '';
    el.classList.add('hidden');
  };

  P.clearPositionErrors = function (side, position) {
    var self = this;
    [
      'error-text-' + side + '-' + position,
      'error-font-' + side + '-' + position,
      'error-upload-' + side + '-' + position,
      'error-icon-' + side + '-' + position,
      'error-terms-' + side + '-' + position + '-text',
      'error-terms-' + side + '-' + position + '-image'
    ].forEach(function (id) { self.clearFieldError(id); });
    var sec = this.section(side, position);
    if (sec) sec.classList.remove('has-error');
  };

  P.clearAllErrors = function () {
    this.eachSidePos(function (side, pos) { this.clearPositionErrors(side, pos); });
    this.clearFieldError('error-terms-all');
    var wrap = this.$('.personalized-terms-checkbox__all');
    if (wrap) wrap.classList.remove('has-error');
  };

  P.markSectionError = function (side, position) {
    var sec = this.section(side, position);
    if (!sec) return;
    sec.classList.add('has-error');
    sec.classList.add('open');
  };

  P.showDrawerError = function (msg) {
      var el = this.$('.personalized-error');
      if (!el) return;
      clearTimeout(el._hideTimer);
      el.classList.remove('hidden');
      el.classList.add('active');
      el.style.color = 'red';
      el.textContent = msg;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });   // ← add this
      el._hideTimer = setTimeout(function () {
        el.classList.remove('active');
        el.classList.add('hidden');
      }, 3000);
  };

  P.scrollToFieldError = function (id) {
    var el = this.id(id);
    if (!el) return;
    var target = el.previousElementSibling || el.parentElement || el;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  /* ============================================================
     VALIDATION
     ============================================================ */
  P.validatePosition = function (side, position, showErrors) {
    var mode = this.mode(side, position);
    var rules = this.rules(side, position);
    var errors = [];
    var firstErrorId = null;
    var self = this;

    function fail(id, msg) {
      errors.push(msg);
      if (!firstErrorId) firstErrorId = id;
      if (showErrors) self.showFieldError(id, msg);
    }

    if (showErrors) this.clearPositionErrors(side, position);

    if (!this.hasContent(side, position)) {
      if (!this.isTouched(side, position)) {
        return { ok: true, empty: true, errors: [], errorId: null };
      }
      if (mode === 'image') fail('error-upload-' + side + '-' + position, MESSAGES.needImage);
      else if (mode === 'icon') fail('error-icon-' + side + '-' + position, MESSAGES.needIcon);
      else fail('error-text-' + side + '-' + position, MESSAGES.needText);
      if (showErrors) this.markSectionError(side, position);
      return { ok: false, empty: true, errors: errors, errorId: firstErrorId };
    }

    if (mode === 'text') {
      if (rules.fontCompulsory) {
        var fontSel = this.$('.font-select[data-side="' + side + '"][data-position="' + position + '"]');
        if (fontSel && !fontSel.value) fail('error-font-' + side + '-' + position, MESSAGES.font);
      }
      if (rules.termsRequired) {
        var tBox = this.id('terms-check-' + side + '-' + position + '-text');
        if (tBox && !tBox.checked) fail('error-terms-' + side + '-' + position + '-text', MESSAGES.terms);
      }
    } else if (mode === 'image') {
      if (rules.termsRequiredImage) {
        var tImg = this.id('terms-check-' + side + '-' + position + '-image');
        if (tImg && !tImg.checked) fail('error-terms-' + side + '-' + position + '-image', MESSAGES.terms);
      }
    }

    if (showErrors && errors.length) this.markSectionError(side, position);
    return { ok: errors.length === 0, empty: false, errors: errors, errorId: firstErrorId };
  };

  P.validateSide = function (side, showErrors) {
    var out = { ok: true, touched: false, errors: [], firstPosition: null, errorId: null };
    var self = this;
    this.$$('.accordion-section[data-side="' + side + '"]').forEach(function (sec) {
      var pos = sec.getAttribute('data-position');
      var v = self.validatePosition(side, pos, showErrors);
      if (!v.empty || !v.ok) out.touched = true;
      if (!v.ok) {
        out.ok = false;
        out.errors = out.errors.concat(v.errors);
        if (!out.firstPosition) { out.firstPosition = pos; out.errorId = v.errorId; }
      }
    });
    return out;
  };

  P.validateAllSides = function (showErrors) {
    var out = { ok: true, touched: false, errors: [], firstSide: null, firstPosition: null, errorId: null };
    var self = this;
    this.sides.forEach(function (s) {
      var v = self.validateSide(s.slug, showErrors);
      if (v.touched) out.touched = true;
      if (!v.ok) {
        out.ok = false;
        out.errors = out.errors.concat(v.errors);
        if (!out.firstSide) {
          out.firstSide = s.slug;
          out.firstPosition = v.firstPosition;
          out.errorId = v.errorId;
        }
      }
    });
    return out;
  };

  P.validateGlobalTerms = function (showErrors) {
    var box = this.id('terms-check--all');
    if (!box) return true;
    if (box.getAttribute('data-required') === 'false') return true;

    var wrap = box.closest('.personalized-terms-checkbox__all');
    if (box.checked) {
      if (wrap) wrap.classList.remove('has-error');
      this.clearFieldError('error-terms-all');
      return true;
    }
    if (showErrors) {
      if (wrap) wrap.classList.add('has-error');
      this.showFieldError('error-terms-all', MESSAGES.terms);
      this.scrollToFieldError('error-terms-all');
    }
    return false;
  };

  P.focusInvalidPosition = function (side, position, errorId) {
    if (!side || !position) return;
    var review = this.id('review-shared');
    if (review && review.style.display === 'block') this.hideReview();
    this.switchMainTab(side);

    var sec = this.section(side, position);
    if (!sec) return;

    var container = sec.closest('.mode-config');
    if (container) {
      toArray(container.querySelectorAll('.accordion-section')).forEach(function (s) {
        if (s !== sec) s.classList.remove('open');
      });
    }
    sec.classList.add('open');

    var self = this;
    if (errorId) setTimeout(function () { self.scrollToFieldError(errorId); }, 120);
    else sec.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  P.syncReviewBtn = function (side) {
    if (!side) return;
    var btn = this.$('.btn-review-all[data-side="' + side + '"]');
    var anyTouched = false;
    var self = this;

    this.$$('.accordion-section[data-side="' + side + '"]').forEach(function (sec) {
      var pos = sec.getAttribute('data-position');
      if (self.hasContent(side, pos)) anyTouched = true;
      if (self.validatePosition(side, pos, false).ok) self.clearPositionErrors(side, pos);
    });

    // if (btn) btn.classList.toggle('disabled', !anyTouched);
  };

  P.syncAllReviewBtns = function () {
    var self = this;
    this.sides.forEach(function (s) { self.syncReviewBtn(s.slug); });
  };

  /* ============================================================
     CAPTURE
     ============================================================ */
  P.capturePosition = function (side, position) {
    if (!this.hasContent(side, position)) return 'empty';

    var v = this.validatePosition(side, position, true);
    if (!v.ok) { this.showDrawerError(v.errors[0]); return 'invalid'; }

    var st = this.get(side, position);
    if (!st) return 'empty';
    var mode = this.mode(side, position);

    if (mode === 'text') {
      var inputs = this.$$('.field-input[data-side="' + side + '"][data-position="' + position + '"]');
      var fontSel = this.$('.font-select[data-side="' + side + '"][data-position="' + position + '"]');
      var fontVal = fontSel ? fontSel.value : '';
      st.type = 'text';
      st.value = inputs.map(function (i) { return i.value.trim(); });
      st.font = fontVal || 'inherit';
      st.fontName = fontVal || null;
      st.imageData = null;
      st.iconIndex = null;
      return 'ok';
    }

    if (mode === 'image') {
      var img = this.id(side + '-' + position + '-img-preview');
      var nameEl = this.id(side + '-' + position + '-img-name');
      st.type = 'image';
      st.imageData = img ? img.src : null;
      st.filename = nameEl ? nameEl.textContent : '';
      st.value = null;
      st.font = null;
      st.iconIndex = null;
      return 'ok';
    }

    if (mode === 'icon') {
      var sel = this.$('.icon-item.selected[data-side="' + side + '"][data-position="' + position + '"]');
      if (!sel) return 'empty';
      st.type = 'icon';
      st.value = sel.dataset.iconName;
      st.iconIndex = parseInt(sel.dataset.iconIndex, 10);
      st.imageData = null;
      st.font = null;
      return 'ok';
    }

    return 'empty';
  };

  P.captureSide = function (side) {
    var sections = this.$$('.accordion-section[data-side="' + side + '"]');
    for (var i = 0; i < sections.length; i++) {
      if (this.capturePosition(side, sections[i].getAttribute('data-position')) === 'invalid') return false;
    }
    return true;
  };

  P.captureAll = function () {
    for (var i = 0; i < this.sides.length; i++) {
      if (!this.captureSide(this.sides[i].slug)) return false;
    }
    return true;
  };

  /* ============================================================
     REVIEW SCREEN
     ============================================================ */
  P.showReview = function (side) {
    this.lastEditedSide = side || this.lastEditedSide;
    var tabs = this.id('main-tabs-bar');
    var panels = this.id('tab-panels-wrap');
    var review = this.id('review-shared');
    if (tabs) tabs.style.display = 'none';
    if (panels) panels.style.display = 'none';
    if (review) review.style.display = 'block';
    this.refreshAllSplitPreviews();
  };

  P.hideReview = function () {
    var tabs = this.id('main-tabs-bar');
    var panels = this.id('tab-panels-wrap');
    var review = this.id('review-shared');
    if (tabs) tabs.style.display = '';
    if (panels) panels.style.display = '';
    if (review) review.style.display = 'none';
    this.switchMainTab(this.lastEditedSide);
  };

  P.handleReviewSide = function (side) {
    if (!side) return;
    var result = this.validateSide(side, true);

    if (!result.touched) { this.showDrawerError(MESSAGES.empty); return; }
    if (!result.ok) {
      this.showDrawerError(result.errors[0]);
      this.focusInvalidPosition(side, result.firstPosition, result.errorId);
      return;
    }
    if (!this.captureSide(side)) return;

    this.updateStateBar();
    this.save();
    this.showReview(side);
  };

  P.handleEdit = function () {
    this.hideReview();
    var side = this.lastEditedSide;
    if (!side || !this.state[side]) return;
    var self = this;

    POSITIONS.forEach(function (position) {
      var s = self.get(side, position);
      if (!s || !s.type) return;

      if (s.type === 'text' && s.value) {
        self.switchMode(side, position, 'text');
        var inputs = self.$$('.field-input[data-side="' + side + '"][data-position="' + position + '"]');
        s.value.forEach(function (val, i) {
          if (!inputs[i]) return;
          inputs[i].value = val || '';
          var row = inputs[i].closest('.field-row');
          var small = row ? row.querySelector('.char-count') : null;
          if (small) small.textContent = (val ? val.length : 0) + '/' + inputs[i].getAttribute('maxlength');
        });
        var fontSel = self.$('.font-select[data-side="' + side + '"][data-position="' + position + '"]');
        if (fontSel && s.fontName) fontSel.value = s.fontName;
        self.updatePreview(side, position);

      } else if (s.type === 'image') {
        self.switchMode(side, position, 'image');

      } else if (s.type === 'icon') {
        self.switchMode(side, position, 'icon');
        self.$$('.icon-item[data-side="' + side + '"][data-position="' + position + '"]').forEach(function (item) {
          item.classList.toggle('selected', item.dataset.iconName === s.value);
        });
        self.updateEmbellishmentIconLabel(side, position);
      }
    });
  };

  P.handleCancel = function (side, position, mode) {
    if (!side || !position) return;
    var self = this;

    if (mode === 'text') {
      this.$$('.field-input[data-side="' + side + '"][data-position="' + position + '"]').forEach(function (i) {
        i.value = '';
        var row = i.closest('.field-row');
        var small = row ? row.querySelector('.char-count') : null;
        if (small) small.textContent = '0/' + (i.getAttribute('maxlength') || '');
      });
      var pv = this.id('preview-area-' + side + '-' + position);
      if (pv) pv.textContent = 'PREVIEW YOUR MESSAGE';

    } else if (mode === 'image') {
      this.clearUpload(side, position);

    } else if (mode === 'icon') {
      this.$$('.icon-item[data-side="' + side + '"][data-position="' + position + '"]').forEach(function (i) {
        i.classList.remove('selected');
      });
      this.updateEmbellishmentIconLabel(side, position);
    }

    var st = this.get(side, position);
    if (st) this.state[side][position] = emptyPositionState();
    this.unmarkTouched(side, position);
    this.clearPositionErrors(side, position);
    this.updateSplitPreview(side, position);
    this.updateStateBar();
    this.syncReviewBtn(side);
    this.save();
  };

  P.clearUpload = function (side, position) {
    var zone = this.id('upload-zone-' + side + '-' + position);
    var img = this.id(side + '-' + position + '-img-preview');
    var nameEl = this.id(side + '-' + position + '-img-name');
    var fileInput = zone ? zone.querySelector('input[type=file]') : null;

    if (img) { img.removeAttribute('src'); img.style.display = 'none'; }
    if (nameEl) { nameEl.textContent = ''; nameEl.style.display = 'none'; }
    if (zone) {
      zone.classList.remove('has-file');
      var ut = zone.querySelector('.upload-text');
      var ui = zone.querySelector('.upload-icon');
      if (ut) ut.style.display = '';
      if (ui) ui.style.display = '';
    }
    if (fileInput) fileInput.value = '';
  };

  /* ============================================================
     PERSISTENCE
     ============================================================ */
  P.save = function () {
    try {
      var toSave = { _termsAll: !!(this.id('terms-check--all') || {}).checked };
      var self = this;
      this.sides.forEach(function (s) {
        toSave[s.slug] = {};
        POSITIONS.forEach(function (pos) {
          var ps = self.get(s.slug, pos);
          if (!ps) return;
          toSave[s.slug][pos] = {
            type: ps.type,
            value: ps.value,
            font: ps.font,
            fontName: ps.fontName,
            imageData: ps.imageData,
            filename: ps.filename,
            iconIndex: ps.iconIndex,
            mode: self.mode(s.slug, pos),
            touched: self.isTouched(s.slug, pos),
            termsText: !!(self.id('terms-check-' + s.slug + '-' + pos + '-text') || {}).checked,
            termsImage: !!(self.id('terms-check-' + s.slug + '-' + pos + '-image') || {}).checked,
            embellishment: ps.embellishment || null
          };
        });
      });
      localStorage.setItem(this.storageKey(), JSON.stringify(toSave));
    } catch (e) {
      console.warn('[adv-personalise] save failed:', e);
    }
  };

  P.restore = function () {
    var saved;
    try {
      var raw = localStorage.getItem(this.storageKey());
      if (!raw) return;
      saved = JSON.parse(raw);
    } catch (e) { return; }
    if (!saved) return;

    var self = this;
    this.sides.forEach(function (sideObj) {
      var side = sideObj.slug;
      if (!saved[side]) return;

      POSITIONS.forEach(function (position) {
        var s = saved[side][position];
        if (!s || !s.type) return;

        self.state[side][position] = Object.assign(emptyPositionState(), s);
        if (s.embellishment) self.state[side][position].embellishment = Object.assign({}, s.embellishment);
        if (s.touched) self.markTouched(side, position);

        self.switchMode(side, position, s.mode || s.type);

        if (s.type === 'text' && s.value) {
          var inputs = self.$$('.field-input[data-side="' + side + '"][data-position="' + position + '"]');
          s.value.forEach(function (val, i) {
            if (!inputs[i]) return;
            inputs[i].value = val || '';
            var row = inputs[i].closest('.field-row');
            var small = row ? row.querySelector('.char-count') : null;
            if (small) small.textContent = (val ? val.length : 0) + '/' + inputs[i].getAttribute('maxlength');
          });
          var fontSel = self.$('.font-select[data-side="' + side + '"][data-position="' + position + '"]');
          if (fontSel && s.fontName) {
            fontSel.value = s.fontName;
            self.selectedFonts[side][position] = s.fontName;
          }
          self.updatePreview(side, position);

        } else if (s.type === 'image' && s.imageData) {
          var img = self.id(side + '-' + position + '-img-preview');
          var nameEl = self.id(side + '-' + position + '-img-name');
          var zone = self.id('upload-zone-' + side + '-' + position);
          if (img) { img.src = s.imageData; img.style.display = 'block'; }
          if (nameEl) { nameEl.textContent = s.filename || ''; nameEl.style.display = 'block'; }
          if (zone) {
            zone.classList.add('has-file');
            var ut = zone.querySelector('.upload-text');
            var ui = zone.querySelector('.upload-icon');
            if (ut) ut.style.display = 'none';
            if (ui) ui.style.display = 'none';
          }

        } else if (s.type === 'icon') {
          self.$$('.icon-item[data-side="' + side + '"][data-position="' + position + '"]').forEach(function (item) {
            item.classList.toggle('selected', item.dataset.iconName === s.value);
          });
          self.updateEmbellishmentIconLabel(side, position);
        }

        var tText = self.id('terms-check-' + side + '-' + position + '-text');
        if (tText) tText.checked = !!s.termsText;
        var tImg = self.id('terms-check-' + side + '-' + position + '-image');
        if (tImg) tImg.checked = !!s.termsImage;

        self.updateSplitPreview(side, position);
      });
    });

    var allBox = this.id('terms-check--all');
    if (allBox) allBox.checked = !!saved._termsAll;

    this.updateStateBar();
    this.syncAllReviewBtns();
  };

  P.reset = function () {
    try { localStorage.removeItem(this.storageKey()); } catch (e) {}

    this.clearAllErrors();
    this.clearAllTouched();
    this._buildEmptyState();

    var self = this;

    this.$$('.field-input').forEach(function (input) {
      input.value = '';
      var row = input.closest('.field-row');
      var small = row ? row.querySelector('.char-count') : null;
      if (small) small.textContent = '0/' + (input.getAttribute('maxlength') || '');
    });

    this.$$('.font-select').forEach(function (sel) { sel.value = ''; });
    this.$$('.icon-item').forEach(function (i) { i.classList.remove('selected'); });
    this.$$('[data-id^="terms-check-"]').forEach(function (b) { b.checked = false; });

    var allWrap = this.$('.personalized-terms-checkbox__all');
    if (allWrap) allWrap.classList.remove('has-error');

    this.eachSidePos(function (side, pos) {
      var pv = self.id('preview-area-' + side + '-' + pos);
      if (pv) pv.textContent = 'PREVIEW YOUR MESSAGE';

      self.clearUpload(side, pos);
      self.updateEmbellishmentIconLabel(side, pos);

      var box = self.id('split-box-' + side + '-' + pos);
      if (box) box.innerHTML = '<span class="split-preview-empty"></span>';
      var group = self.id('split-group-' + side + '-' + pos);
      if (group) group.style.display = 'none';
    });

    this.sides.forEach(function (s) {
      var el = self.id('state-' + s.slug + '-display');
      if (el) { el.textContent = '\u2014'; el.classList.remove('filled'); }
    });
    this.$$('.main-tab').forEach(function (t) { t.classList.remove('has-data'); });

    this.hideReview();

    if (this.sides.length) {
      var first = this.sides[0].slug;
      this.switchMainTab(first);
      this.eachSidePos(function (side, pos) { self.switchMode(side, pos, 'text'); });
      this.lastEditedSide = first;
    }

    this.syncAllReviewBtns();
  };

  /* Rebuild state from what is currently rendered (bfcache / soft nav). */
  P.hydrateFromDom = function () {
    var self = this;

    this.eachSidePos(function (side, pos) {
      if (!self.get(side, pos)) return;

      var sec = self.section(side, pos);
      var activeBtn = self.$('.mode-btn.active[data-side="' + side + '"][data-position="' + pos + '"]');
      var mode = (activeBtn && activeBtn.dataset.mode) ||
        (sec && sec.getAttribute('data-active-mode')) ||
        self.mode(side, pos);
      self.activeMode[side][pos] = mode;

      // if (!self.hasContent(side, pos)) return;
      // self.markTouched(side, pos);

      var st = self.state[side][pos];
      if (sec && sec.classList.contains('open')) self.markTouched(side, pos);

      if (!self.hasContent(side, pos)) return;
      self.markTouched(side, pos);

      if (mode === 'text') {
        var inputs = self.$$('.field-input[data-side="' + side + '"][data-position="' + pos + '"]');
        var fontSel = self.$('.font-select[data-side="' + side + '"][data-position="' + pos + '"]');
        st.type = 'text';
        st.value = inputs.map(function (i) { return i.value.trim(); });
        st.fontName = (fontSel && fontSel.value) || null;
        st.font = st.fontName || 'inherit';
        self.selectedFonts[side][pos] = fontSel ? fontSel.value : '';
        inputs.forEach(function (i) {
          var row = i.closest('.field-row');
          var small = row ? row.querySelector('.char-count') : null;
          if (small) small.textContent = i.value.length + '/' + (i.getAttribute('maxlength') || '');
        });
        self.updatePreview(side, pos);

      } else if (mode === 'image') {
        var img = self.id(side + '-' + pos + '-img-preview');
        var nameEl = self.id(side + '-' + pos + '-img-name');
        if (img && img.getAttribute('src')) {
          st.type = 'image';
          st.imageData = img.src;
          st.filename = nameEl ? nameEl.textContent : '';
        }

      } else if (mode === 'icon') {
        var sel = self.$('.icon-item.selected[data-side="' + side + '"][data-position="' + pos + '"]');
        if (sel) {
          st.type = 'icon';
          st.value = sel.dataset.iconName;
          st.iconIndex = parseInt(sel.dataset.iconIndex, 10);
        }
        self.updateEmbellishmentIconLabel(side, pos);
      }

      self.updateSplitPreview(side, pos);
    });

    this.updateStateBar();
    this.syncAllReviewBtns();
  };

  /* ============================================================
     OPEN / CLOSE
     ============================================================ */
  P.open = function () {
    AdvancePersonalise._active = this;
    this.root.classList.remove('hidden');
    this.root.classList.add('active');
    document.body.classList.add('personalise-drawer-open');
    var pop = this.root.closest('.pop-up');
    if (pop) pop.classList.add('active');
    this.restore();
    this.hydrateFromDom();
  };

  P.close = function () {
    this.root.classList.remove('active');
    this.root.classList.add('hidden');
    document.body.classList.remove('personalise-drawer-open');
    var pop = this.root.closest('.pop-up');
    if (pop) pop.classList.remove('active');
    if (AdvancePersonalise._active === this) AdvancePersonalise._active = null;
  };

  P.isOpen = function () { return this.root.classList.contains('active'); };

  /* ============================================================
     CART PROPERTY BUILDERS
     ============================================================ */
  P.positionLabel = function (side, position) {
    return this.sideLabel(side) + ' ' + cap(position);
  };

  P.embellishmentText = function (st) {
    var emb = st && st.embellishment;
    if (!emb) return '';
    var on = emb.enabled || emb.checked;
    var name = emb.iconName || emb.icon;
    if (!on || !name) return '';
    return 'Embellishment: ' + name + (emb.position ? ' (' + emb.position + ')' : '');
  };

  P.positionVal = function (side, position) {
    var s = this.get(side, position);
    if (!s || !s.type) return '';
    var val = '';
    if (s.type === 'text') {
      var lines = (s.value || []).filter(Boolean).join(' | ');
      val = s.fontName ? lines + ' (Font: ' + s.fontName + ')' : lines;
    } else if (s.type === 'icon') {
      val = s.value || '';
    } else if (s.type === 'image') {
      val = s.filename || 'Image uploaded';
    }
    var emb = this.embellishmentText(s);
    if (emb) val = val ? val + ' | ' + emb : emb;
    return val;
  };

  P.sideVal = function (side) {
    var parts = [];
    var self = this;
    POSITIONS.forEach(function (pos) {
      var v = self.positionVal(side, pos);
      if (v) parts.push(cap(pos) + ': ' + v);
    });
    return parts.join(' | ');
  };

  P.engravingLabel = function () {
    var self = this;
    return this.sides.map(function (s) {
      return s.label + ': ' + self.sideVal(s.slug);
    }).join(' \u2014 ');
  };

  P.hasAnyImage = function () {
    var self = this;
    return this.sides.some(function (s) {
      return POSITIONS.some(function (pos) {
        var st = self.get(s.slug, pos);
        return st && st.type === 'image';
      });
    });
  };

    P.buildProperties = function () {
        var self = this;
        var props = {};
        var fontsByLabel = {};
        var fontAdded = false;

        this.sides.forEach(function (s) {
            POSITIONS.forEach(function (pos) {   // top, middle, bottom — fixed order
                var st = self.get(s.slug, pos);
                if (!st || st.type !== 'text' || !st.fontName) return;
                var sec = self.section(s.slug, pos);
                var label = (sec && sec.getAttribute('data-prop-prefix')) || self.positionLabel(s.slug, pos);
                fontsByLabel[label] = st.fontName;
            });
        });

        var uniqueFonts = Object.keys(fontsByLabel)
            .map(function (k) { return fontsByLabel[k]; })
            .filter(function (v, i, a) { return a.indexOf(v) === i; });
        var fontMode = uniqueFonts.length === 1 ? 'unified' : (uniqueFonts.length > 1 ? 'perLabel' : 'none');

        this.sides.forEach(function (s) {
            POSITIONS.forEach(function (pos) {
                var st = self.get(s.slug, pos);
                if (!st || !st.type) return;

                var sec = self.section(s.slug, pos);
                var label = (sec && sec.getAttribute('data-prop-prefix')) || self.positionLabel(s.slug, pos);

                if (st.type === 'text') {
                    (st.value || []).filter(Boolean).forEach(function (line, i) {
                        props[label + ' - Line ' + (i + 1)] = line;
                    });

                } else if (st.type === 'icon') {
                    props[label + ' - Icon'] = st.value || '';

                } else if (st.type === 'image' && st.rawFile) {
                 
                }

                var emb = st.embellishment;
                if (emb && (emb.checked || emb.enabled)) {
                    var name = emb.iconName || emb.icon;
                    if (name) props[label + ' - Embellishment Icon'] = name;
                    if (emb.position) props[label + ' - Embellishment Position'] = emb.position;
                }
                if (st.type === 'text' && st.fontName) {
                    if (fontMode === 'unified' && !fontAdded) {
                        props['Font Style'] = uniqueFonts[0];
                        fontAdded = true;
                    } else if (fontMode === 'perLabel') {
                        props[label + ' - Font Style'] = st.fontName;
                    }
                }
            });
        });

        return props;
    };
  /* ============================================================
     ADD TO CART
     ============================================================ */
  P.addToCart = function (btn) {
    var self = this;
    if (btn.classList.contains('loading')) return;
    if (window._bybCartEditLineKey) return;

    var validation = this.validateAllSides(true);
    if (!validation.touched) { this.showDrawerError(MESSAGES.empty); return; }
    if (!validation.ok) {
      this.showDrawerError(validation.errors[0]);
      this.focusInvalidPosition(validation.firstSide, validation.firstPosition, validation.errorId);
      return;
    }
    if (!this.validateGlobalTerms(true)) { this.showDrawerError(MESSAGES.terms); return; }
    if (!this.captureAll()) return;

    var urlParams = new URLSearchParams(window.location.search);
    var mainVariantId = urlParams.get('variant') ||
      btn.getAttribute('data-default-variant') ||
      (this.$('.product-variant-id') || {}).value;

    if (!mainVariantId) { this.showDrawerError(MESSAGES.noVariant); return; }

    var personalizeInput = this.$('.personlize');
    var personalizeId = personalizeInput ? personalizeInput.value : null;
    var personalizeName = personalizeInput ? personalizeInput.getAttribute('data-name') : '';
    if (!personalizeId) { this.showDrawerError(MESSAGES.noPersonalise); return; }
    var isFree = personalizeId === 'free';

    var headerEl = this.$('.personalised_header');
    var mainProductTitle = headerEl ? headerEl.getAttribute('data-product') : '';
    var stamp = 't_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
    var loader = this.id('cart-loader') || document.querySelector('[data-id="cart-loader"]');

    btn.classList.add('loading');
    if (loader) loader.style.display = 'flex';

    var props = this.buildProperties();
    props._personalise_product = 'true';
    props._timestamp = stamp;

    var run;

    if (this.hasAnyImage()) {
      var fd = new FormData();
      fd.append('id', mainVariantId);
      fd.append('quantity', '1');

      Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });

      this.sides.forEach(function (s) {
        POSITIONS.forEach(function (pos) {
          var st = self.get(s.slug, pos);
          if (!st || st.type !== 'image' || !st.rawFile) return;
          var label = self.positionLabel(s.slug, pos) + ' - Image';
          fd.append('properties[' + label + ']', st.rawFile, st.filename || (s.slug + '-' + pos + '-image.png'));
        });
      });

      if (!isFree) fd.append('properties[Personalize Product]', personalizeName || '');

      run = fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Add to cart failed'); });
          return res.json();
        })
        .then(function (data) {
          if (isFree) return data;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: personalizeId,
              quantity: 1,
              parent_line_key: data.key,
              properties: {
                _bundle_id: mainVariantId,
                _timestamp: stamp,
                'Product added with': mainProductTitle,
                _personalise_product: 'true'
              }
            })
          }).then(function (r2) {
            if (!r2.ok) throw new Error('Personalize product add failed');
            return r2.json();
          });
        });

    } else {
      if (!isFree) props['Personalize Product'] = personalizeName;

      var items = [{ id: mainVariantId, quantity: 1, properties: props }];
      if (!isFree) {
        items.push({
          id: personalizeId,
          quantity: 1,
          parent_id: mainVariantId,
          properties: {
            _bundle_id: mainVariantId,
            _timestamp: stamp,
            'Product added with': mainProductTitle,
            _personalise_product: 'true'
          }
        });
      }

      run = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      });
    }

    run
      .then(function () {
        if (typeof window.refreshCartDrawer === 'function') return window.refreshCartDrawer();
      })
      .then(function () {
        self.reset();
        self.close();
      })
      .catch(function (err) {
        console.error('[adv-personalise] add to cart error:', err);
        self.showDrawerError(err.message || String(err));
      })
      .then(function () {
        btn.classList.remove('loading');
        if (loader) loader.style.display = 'none';
      });
  };

  /* ============================================================
     BUILDER (BYB) ADD / UPDATE
     ============================================================ */
  P.snapshot = function () {
    var out = {};
    var self = this;
    this.sides.forEach(function (s) {
      out[s.slug] = {};
      POSITIONS.forEach(function (pos) {
        var src = self.get(s.slug, pos) || emptyPositionState();
        var copy = Object.assign({}, src);
        if (Array.isArray(src.value)) copy.value = src.value.slice();
        if (src.embellishment) copy.embellishment = Object.assign({}, src.embellishment);
        out[s.slug][pos] = copy;
      });
    });
    return out;
  };

  P.builderAdd = function (btn) {
    if (btn.classList.contains('loading')) return;
    if (window._bybCartEditLineKey) return;

    var validation = this.validateAllSides(true);
    if (!validation.touched) { this.showDrawerError(MESSAGES.empty); return; }
    if (!validation.ok) {
      this.showDrawerError(validation.errors[0]);
      this.focusInvalidPosition(validation.firstSide, validation.firstPosition, validation.errorId);
      return;
    }
    if (!this.validateGlobalTerms(true)) { this.showDrawerError(MESSAGES.terms); return; }
    if (!this.captureAll()) return;

    var captured = this.snapshot();
    var label = this.engravingLabel();
    var variantInput = this.$('.product-variant-id');
    var variantId = variantInput ? variantInput.value : null;
    var headerEl = this.$('.personalised_header');
    var productTitle = headerEl ? headerEl.getAttribute('data-product') : '';
    var lineKey = btn.getAttribute('data-product-line') || this.root.getAttribute('data-key') || null;

    /* editing an existing charm inside the builder sidebar */
    if (window._bybEditingCharmVariantId) {
      var editingVariantId = window._bybEditingCharmVariantId;
      var editingItem = window._bybEditingCharmItem;
      var bybState = window._bybState;
      var charm = bybState && bybState.charmsSelected
        ? bybState.charmsSelected.filter(function (c) { return String(c.variantId) === String(editingVariantId); })[0]
        : null;

      if (charm) {
        charm.variant = label;
        if (variantId) charm.variantId = variantId;
        charm._personaliseState = captured;
      }

      if (editingItem) {
        var variantEl = editingItem.querySelector('.byb-sidebar__additional-variant');
        if (variantEl && typeof window.bybFormatVariantHTML === 'function') {
          var temp = document.createElement('div');
          temp.innerHTML = window.bybFormatVariantHTML(label);
          if (temp.firstChild) variantEl.parentNode.replaceChild(temp.firstChild, variantEl);
        }
        if (charm && charm.variantId) editingItem.dataset.variantId = charm.variantId;
      }

      window._bybEditingCharmVariantId = null;
      window._bybEditingCharmItem = null;
      if (typeof window._bybUpdateSummaryFooter === 'function') window._bybUpdateSummaryFooter();

      this.close();
      this.reset();
      return;
    }

    var priceEl = this.$('.byb-injected-product .price');
    var priceRaw = priceEl ? priceEl.textContent.replace(/[^0-9.]/g, '') : '0';
    var price = Math.round(parseFloat(priceRaw) * 100) || 0;

    this.close();
    this.reset();

    document.dispatchEvent(new CustomEvent('byb:personalised-charm-add', {
      detail: {
        title: productTitle,
        variantId: variantId,
        price: price,
        lineKey: lineKey,
        engravingLabel: label,
        capturedState: captured,
        drawer: this.root
      }
    }));
  };

  /* ============================================================
     REGISTRY / BOOT
     ============================================================ */
  var instances = [];

  var AdvancePersonalise = {
    _active: null,

    init: function (scope) {
      var nodes = toArray((scope || document).querySelectorAll(ROOT_SEL));
      if (scope && scope.nodeType === 1 && scope.matches && scope.matches(ROOT_SEL)) nodes.push(scope);
      nodes.forEach(function (node) {
        if (node.__advPersonalise) return;
        try {
          instances.push(new AdvPersonalise(node));
        } catch (e) {
          console.error('[adv-personalise] init failed:', e, node);
        }
      });
      return instances;
    },

    get: function (elOrSelector) {
      var el = typeof elOrSelector === 'string' ? document.querySelector(elOrSelector) : elOrSelector;
      if (!el) return AdvancePersonalise.active();
      var root = el.closest ? (el.matches(ROOT_SEL) ? el : el.closest(ROOT_SEL)) : null;
      if (!root) return AdvancePersonalise.active();
      if (!root.__advPersonalise) AdvancePersonalise.init(root);
      return root.__advPersonalise || null;
    },

    all: function () {
      return instances.filter(function (i) { return document.contains(i.root); });
    },

    active: function () {
      if (AdvancePersonalise._active && document.contains(AdvancePersonalise._active.root)) {
        return AdvancePersonalise._active;
      }
      var open = AdvancePersonalise.all().filter(function (i) { return i.isOpen(); })[0];
      return open || AdvancePersonalise.all()[0] || null;
    },

    byProduct: function (productId, itemKey) {
      return AdvancePersonalise.all().filter(function (i) {
        if (String(i.productId) !== String(productId)) return false;
        if (itemKey && String(i.itemKey) !== String(itemKey)) return false;
        return true;
      })[0] || null;
    },

    Instance: AdvPersonalise,
    POSITIONS: POSITIONS,
    MESSAGES: MESSAGES
  };

  window.AdvancePersonalise = AdvancePersonalise;

  /* ---------------------------------------------------- open triggers */
  document.addEventListener('click', function (e) {
    /* overlay click closes the drawer above it */
    var overlay = e.target.closest('.overlay');
    if (overlay) {
      var pop = overlay.closest('.pop-up');
      var root = pop ? pop.querySelector(ROOT_SEL) : null;
      var inst = root ? AdvancePersonalise.get(root) : null;
      if (inst && inst.isOpen()) { inst.close(); return; }
    }

    var trigger = e.target.closest('.Personalise_button, [data-personalise-open]');
    if (!trigger) return;

    var productId = trigger.getAttribute('data-product-id') ||
      (trigger.closest('[data-product-id]') || {}).getAttribute &&
      trigger.closest('[data-product-id]').getAttribute('data-product-id');
    var itemKey = trigger.getAttribute('data-item-key') || trigger.getAttribute('data-key');

    var inst = null;
    if (productId) inst = AdvancePersonalise.byProduct(productId, itemKey);
    if (!inst && itemKey) {
      var byKey = AdvancePersonalise.all().filter(function (i) { return String(i.itemKey) === String(itemKey); })[0];
      inst = byKey || null;
    }
    if (!inst) inst = AdvancePersonalise.all()[0];
    if (!inst) return;

    e.preventDefault();
    inst.open();
    document.querySelectorAll('.Personalise_button').forEach(function (b) { b.classList.remove('active'); });
    trigger.classList.add('active');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var inst = AdvancePersonalise.active();
    if (inst && inst.isOpen()) inst.close();
  });

  /* ------------------------------------------------- cart drawer refresh */
  if (typeof window.refreshCartDrawer !== 'function') {
    window.refreshCartDrawer = function () {
      return fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (res) {
          var ct = res.headers.get('content-type');
          if (!ct || ct.indexOf('application/json') === -1) throw new Error('Expected JSON, got: ' + ct);
          return res.json();
        })
        .then(function (data) {
          if (data['cart-drawer']) {
            var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
            var next = doc.querySelector('cart-drawer');
            var cur = document.querySelector('cart-drawer');
            if (next && cur) {
              cur.innerHTML = next.innerHTML;
              cur.classList.remove('is-empty');
              cur.classList.add('active');
              cur.scrollTop = 0;
            }
          }
          if (data['cart-icon-bubble']) {
            var bDoc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
            var nextBubble = bDoc.getElementById('shopify-section-cart-icon-bubble');
            var curBubble = document.getElementById('cart-icon-bubble');
            if (nextBubble && curBubble) curBubble.innerHTML = nextBubble.innerHTML;
          }
          document.querySelectorAll('.Personalise_button').forEach(function (b) { b.classList.remove('active'); });
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('.cart-count');
          if (countEl) countEl.textContent = cart.item_count;
          return cart;
        })
        .catch(function (err) { console.error('[adv-personalise] cart refresh failed:', err); });
    };
  }

  /* ---------------------------------------------- legacy global proxies */
  function activeOr(fnName) {
    return function () {
      var inst = AdvancePersonalise.active();
      if (!inst || typeof inst[fnName] !== 'function') return undefined;
      return inst[fnName].apply(inst, arguments);
    };
  }

  window._byId = function (id, scope) {
    return (scope || document).querySelector('[data-id="' + id + '"]');
  };

  /* personalized.js already owns these names. Keep its implementation and
     dispatch on the drawer that was passed in, so a quick drawer is never
     reset or saved by the advance controller and vice versa. */
  var prevReset = window.resetDrawerState;
  var prevSave = window.saveDrawerStateToStorage;
  var prevRestore = window.restoreDrawerStateFromStorage;

  function isAdvanceEl(el) {
    return !!(el && el.nodeType === 1 && el.closest && el.closest(ROOT_SEL));
  }

  window.resetDrawerState = function (drawer) {
    if (drawer && drawer.nodeType === 1 && !isAdvanceEl(drawer)) {
      if (typeof prevReset === 'function') return prevReset.apply(this, arguments);
      return;
    }
    var inst = drawer ? AdvancePersonalise.get(drawer) : AdvancePersonalise.active();
    if (inst && inst.isOpen && (drawer || inst.isOpen())) return inst.reset();
    if (!drawer && typeof prevReset === 'function') return prevReset.apply(this, arguments);
    if (inst) return inst.reset();
  };

  window.saveDrawerStateToStorage = function (drawer) {
    if (drawer && drawer.nodeType === 1 && !isAdvanceEl(drawer)) {
      if (typeof prevSave === 'function') return prevSave.apply(this, arguments);
      return;
    }
    var inst = drawer ? AdvancePersonalise.get(drawer) : AdvancePersonalise.active();
    if (inst) return inst.save();
    if (typeof prevSave === 'function') return prevSave.apply(this, arguments);
  };

  window.restoreDrawerStateFromStorage = function (drawer) {
    if (drawer && drawer.nodeType === 1 && !isAdvanceEl(drawer)) {
      if (typeof prevRestore === 'function') return prevRestore.apply(this, arguments);
      return;
    }
    var inst = drawer ? AdvancePersonalise.get(drawer) : AdvancePersonalise.active();
    if (inst) return inst.restore();
    if (typeof prevRestore === 'function') return prevRestore.apply(this, arguments);
  };

  window.restoreIconSelectionFromStorage = window.restoreDrawerStateFromStorage;
  window.hydrateStateFromDom = activeOr('hydrateFromDom');
  window.syncReviewAllButtonState = activeOr('syncReviewBtn');
  window.validatePosition = activeOr('validatePosition');
  window.validateSide = activeOr('validateSide');
  window.validateAllSides = activeOr('validateAllSides');
  window.validateGlobalTerms = activeOr('validateGlobalTerms');
  window.focusInvalidPosition = activeOr('focusInvalidPosition');
  window.clearAllPersonaliseErrors = activeOr('clearAllErrors');
  window.clearAllPositionTouched = activeOr('clearAllTouched');
  window._bybGetSideVal = activeOr('sideVal');

  /* Advance state is exposed under its own name only.

     window._personaliseState is NOT touched here: personalized.js creates it
     as a plain object and keeps an internal reference to it, so replacing it
     with a getter would silently redirect every quick-drawer write into the
     advance instance and leave the quick previews blank. Anything that wants
     advance state should read window._advancePersonaliseState. */
  Object.defineProperty(window, '_advancePersonaliseState', {
    configurable: true,
    get: function () { var i = AdvancePersonalise.active(); return i ? i.state : {}; }
  });

  /* ------------------------------------------------------------- boot */
  function boot() { AdvancePersonalise.init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* drawers injected later (builder / cart edit / section render) */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(ROOT_SEL)) { AdvancePersonalise.init(n); continue; }
          if (n.querySelector && n.querySelector(ROOT_SEL)) AdvancePersonalise.init(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    AdvancePersonalise.all().forEach(function (i) { i.hydrateFromDom(); });
  });
})();